import React from 'react'
import SignUp from '../components/SignUp'

const SignUpScreen =(props)=>{
    return (
            <SignUp {...props}/>
    )
}
export default SignUpScreen